/* global ol */

var angular = require('angular');
var util = require('./util');
var style = require('./style');

function CarLayer(route, clock) {
  this.route = route;
  this.visible = true;
  this.hover = false;

  this.addFeature();
  this.addLayer();
  this.addOverlay();

  this.updatePositionAndVisibility();
  clock.everyMinute(this.updatePositionAndVisibility.bind(this));
}

CarLayer.prototype.addFeature = function() {
  this.feature = new ol.Feature();
  this.feature.set('route', this.route, true);
  this.feature.set('layer', this, true);
};

CarLayer.prototype.addLayer = function() {
  this.layer = new ol.layer.Vector({
    source: new ol.source.Vector({
      features: [this.feature]
    }),
    style: this.style.bind(this),
    updateWhileAnimating: true,
    updateWhileInteracting: true,
    renderBuffer: 24
  });

  this.layer.set('route', this.route, true);
};

CarLayer.prototype.addOverlay = function() {
  this.overlay = new ol.Overlay({
    element: document.createElement('div'),
    stopEvent: false,
    className: 'car-overlay ol-overlay-container ol-selectable'
  });

  this.updateClass();
};

CarLayer.prototype.updateClass = function() {
  var element = this.overlay.getElement();
  var classes = ['car-icon', 'car-color-' + this.route.color];

  if (this.hover) classes.push('hover');
  angular.element(element.parentNode).toggleClass('hover', this.hover);

  element.className = classes.join(' ');
};

CarLayer.prototype.updatePositionAndVisibility = function() {
  var position = {
    latitude: this.route.driverPositionLatitude,
    longitude: this.route.driverPositionLongitude
  };

  var displayCar = this.visible &&
    position.latitude &&
    position.longitude &&
    this.route.driverPositionIsRecent();

  var coordinate = displayCar ? util.coordinate(position) : null;

  if (! util.equalCoordinates(coordinate, this.overlay.getPosition())) {
    this.overlay.setPosition(coordinate);
    this.feature.setGeometry(displayCar ? util.point(position) : null);
  }
};

CarLayer.prototype.setVisible = function(visible) {
  this.visible = visible;
  this.layer.setVisible(visible);
  this.updatePositionAndVisibility();
};

CarLayer.prototype.setHover = function(hover) {
  this.hover = hover;
  this.updateClass();
};

CarLayer.prototype.style = function(feature, resolution) {
  var options = {
    radius: 11,
    color: 'transparent'
  };

  return style(options, feature, resolution);
};

module.exports = CarLayer;



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/lib/map/carLayer.js
 ** module id = 174
 ** module chunks = 1
 **/